import { OrangeBook } from "../../models/orange_book/orange_book";
import { OrangeBookJsEnv } from "../../models/orange_book/orange_book_js_env";
import { TypedEvent } from "../../typed_event";
import { OrangeBookContainer } from "../../views/pc/orange_book/orange_book_container";

export class OrangeBookAction {
  static readonly UPDATE_EVENT = new TypedEvent<OrangeBookJsEnv>();
  private static state: OrangeBook;
  static async init() {
    this.state = new OrangeBook(new OrangeBookJsEnv('', '', '', '', ''));
    this.setParameters();
    new OrangeBookContainer(this.state.getModel()); // NOSONAR
  }

  private static getElementByIdWithDefaultValue(id: string) {
    return (document.getElementById(id) as HTMLInputElement | null)?.value || '';
  }

  static async setParameters() {
    const refineKbn = OrangeBookAction.getElementByIdWithDefaultValue('orange-book-refineKbn')
    const callBackKbn = OrangeBookAction.getElementByIdWithDefaultValue('orange-book-callBackKbn')
    const categoryLl = OrangeBookAction.getElementByIdWithDefaultValue('orange-book-categoryLl')
    const categoryL = OrangeBookAction.getElementByIdWithDefaultValue('orange-book-categoryL')

    this.state.setRefineKbn(refineKbn);
    this.state.setCallBackKbn(callBackKbn);
    this.state.setLlCategoryCode(categoryLl);
    this.state.setLCategoryCode(categoryL);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static async getOrangeBookCode(inputWord: string) {
    this.state.updateInputWord(inputWord);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
